import React from 'react';
import { Sec, SH } from '../components/Section';
import { Crd } from '../components/Button';
import { PlatformShowcase } from '../components/PlatformShowcase';
import { C } from '../constants';
import { useTheme } from '../contexts/ThemeContext';
import { motion } from 'framer-motion';

export const PlatformFeatures = () => {
  const { theme } = useTheme();

  // Exact original content - organized by category
  const features = [
    {
      category: 'INTELLIGENCE',
      items: [
        { title: 'DecX Score & Analysis', desc: 'Know where your deck stands across 5 dimensions.' },
        { title: 'Unexplored Intelligence', desc: "Discover gaps you didn't know existed." },
        { title: 'Audience Insights', desc: "Understand who you're pitching — and what they need." },
        { title: 'Industry Trends', desc: "See what's working in your sector right now." }
      ]
    },
    {
      category: 'CONSULTATION',
      items: [
        { title: '1:1 Strategy Calls', desc: '30-minute expert sessions on deck, positioning, or GTM.' }
      ]
    },
    {
      category: 'ARTEFACTS',
      items: [
        { title: 'Pitch Canvas', desc: 'One-page strategic framework for your narrative.' },
        { title: 'Deck Rebuild Prompts', desc: 'AI-powered prompts to rewrite weak sections.' },
        { title: 'Outreach Sequences', desc: 'Email + LinkedIn + WhatsApp sequences.' },
        { title: 'Brand Videos', desc: 'Quick-consume videos to speed buyer decisions.' }
      ]
    }
  ];

  return (
    <Sec id="features" dark={theme === 'light'}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <SH
          eyebrow="WHAT'S INSIDE"
          title="A Complete Intelligence &"
          accent="Enablement Platform"
          center
        />

        {/* Interactive Platform Showcase */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          style={{ marginTop: '48px', marginBottom: '64px' }}
        >
          <PlatformShowcase />
        </motion.div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '48px', marginTop: '48px' }}>
          {features.map((section, sectionIndex) => (
            <div key={sectionIndex}>
              <div
                style={{
                  fontSize: '12px',
                  fontWeight: 700,
                  letterSpacing: '0.15em',
                  color: C.secondary,
                  marginBottom: '24px',
                  paddingBottom: '12px',
                  borderBottom: `1px solid ${C.secondary}30`
                }}
              >
                {section.category}
              </div>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
                  gap: '20px'
                }}
              >
                {section.items.map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ delay: i * 0.1 }}
                    viewport={{ once: true }}
                  >
                    <Crd data-testid={`feature-${section.category.toLowerCase()}-${i}`}>
                      <h3
                        style={{
                          fontSize: '17px',
                          fontWeight: 700,
                          marginBottom: '10px',
                          fontFamily: "'Sansation', sans-serif"
                        }}
                      >
                        {item.title}
                      </h3>
                      <p
                        className="font-[Manrope]"
                        style={{
                          fontSize: '14px',
                          lineHeight: 1.6,
                          opacity: 0.75
                        }}
                      >
                        {item.desc}
                      </p>
                    </Crd>
                  </motion.div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Sec>
  );
};
